module.exports = __webpack_public_path__ + "static/media/edit_role_definition.72978bdb.svg";